import React, { useContext } from 'react';
import { StateContext } from '../../StateContext';
import './menu.css';
import { PageItems } from '../../Pages';
import { logoutCall } from '../../Services/APICalls/apicalls';
import { useLanguage } from '../../Services/LanguageContext';
import { useTheme } from '../../Services/ThemeContext';

// Icon components
const ProjectsIcon = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9C21 7.89543 20.1046 7 19 7H13L11 5H5C3.89543 5 3 5.89543 3 7Z" />
    </svg>
);

const MechanicsIcon = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21V19C23 17.1362 21.7252 15.5701 20 15.126" />
        <path d="M16 3.12598C17.7252 3.56983 19 5.13616 19 6.99998C19 8.8638 17.7252 10.4301 16 10.874" />
    </svg>
);

const SunIcon = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
);

const MoonIcon = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
);

const LogoutIcon = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9" />
        <polyline points="16,17 21,12 16,7" />
        <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);

const ShieldIcon = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
);

const Menu = () => {
    const { loginData, setLoginData } = useContext(StateContext);
    const { page, setPage } = useContext(StateContext);
    const { t, language, setLanguage } = useLanguage();
    const { theme, toggleTheme, isDark } = useTheme();

    const logoutHandler = () => {
        logoutCall(loginData.user.userName);
        setLoginData(null);
    };

    return (
        <nav className='sidebar'>
            <div>
                <div className='sidebar-logo'>
                    <img src='https://www.j-twee.nl/wp-content/themes/jtwee/img/logo.png' alt='Logo' />
                </div>

                <div className='nav-items'>
                    <button
                        className={`nav-item ${page === PageItems.PROJECTS ? 'active' : ''}`}
                        onClick={() => setPage(PageItems.PROJECTS)}
                    >
                        <span className='nav-item-icon'>
                            <ProjectsIcon />
                        </span>
                        <span className='nav-item-text'>{t('projects')}</span>
                    </button>

                    <button
                        className={`nav-item ${page === PageItems.MECHANIC ? 'active' : ''}`}
                        onClick={() => setPage(PageItems.MECHANIC)}
                    >
                        <span className='nav-item-icon'>
                            <MechanicsIcon />
                        </span>
                        <span className='nav-item-text'>{t('mechanics')}</span>
                    </button>

                    {loginData?.user?.isAdmin && (
                        <button
                            className={`nav-item ${page === PageItems.ADMIN ? 'active' : ''}`}
                            onClick={() => setPage(PageItems.ADMIN)}
                        >
                            <span className='nav-item-icon'>
                                <ShieldIcon />
                            </span>
                            <span className='nav-item-text'>{t('admin')}</span>
                        </button>
                    )}
                </div>
            </div>

            <div className='sidebar-bottom'>
                <button
                    className='theme-toggle'
                    onClick={toggleTheme}
                    title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
                >
                    <span className='theme-toggle-icon'>
                        {isDark ? <SunIcon /> : <MoonIcon />}
                    </span>
                    <span className='theme-toggle-text'>
                        {isDark ? 'Light Mode' : 'Dark Mode'}
                    </span>
                </button>

                <button
                    className='lang-toggle'
                    onClick={() => setLanguage(language === 'nl' ? 'en' : 'nl')}
                    title={t('switchToLanguage')}
                >
                    {language === 'nl' ? '🇬🇧 EN' : '🇳🇱 NL'}
                </button>

                <button className='logout-btn' onClick={logoutHandler}>
                    <span className='nav-item-icon'>
                        <LogoutIcon />
                    </span>
                    <span className='logout-btn-text'>{t('logout')}</span>
                </button>
            </div>
        </nav>
    );
};

export default Menu;
